import React, { HTMLProps } from 'react';
import s from './rating.module.css';
import cn from 'classnames';
import { StarIcon } from '../../assets/svg/star';

interface RatingProps extends Omit<HTMLProps<HTMLDivElement>, 'onChange'> {
  rate: number;
  onChange?: (rate: number) => void;
  single?: boolean;
}

export const Rating: React.FC<RatingProps> = (props) => {
  const { rate, onChange, readOnly, single, ...other } = props;

  const handleClick = (index: number) => {
    if (!readOnly) {
      onChange?.(index + 1);
    }
  };

  return (
    <div className={s.rating} {...other}>
      {single && (
        <div className={s.single}>
          {rate}
          <StarIcon className={cn(s.star, s.single, s.filled)} role="button" />
        </div>
      )}
      {!single &&
        [...Array(5)].map((_, index) => (
          <StarIcon
            key={index}
            data-testid={`star-${index}`}
            className={cn(s.star, index < rate && s.filled, readOnly && s.readonly)}
            onClick={() => handleClick(index)}
            role="button"
          />
        ))}
    </div>
  );
};
